
import moment from 'moment'


import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  // PeriodsC,
  PeriodsCtx,
} from '$src/components/periods'
import {
  IncludeUbprs,
  ReportsCtx,
  TriSelect,
} from '$src/components/reports'
import {
  SchedulesCtx,
} from '$src/components/schedules'


/*
 * CriterionModal
**/
const CriterionModal = (props) => {
  // logg(props, 'CriterionModal')
  // const {
  //   eol, setEol,
  //   lineitems, setLineitems,
  // } = props

  // const apiRouter = useApiRouter()

  /* ctx */

  const {
    setLoading,
    userConfig,
  } = useContext(AppCtx)

  const {
    criterionModalOpen, setCriterionModalOpen,
    query, setQuery,
  } = useContext(BanksCtx)

  const {
    periodsList,
  } = useContext(PeriodsCtx)

  const {
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'SchedulesCtx in CriterionModal')


  // const {
  //   allUbprCodes,
  // } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in AdvancedReportLineitem')


  /* state */

  const [ filteredUbprsList, setFilteredUbprsList ] = useState([])
  // const [ selectedPeriod,    setSelectedPeriod ]    = useState([])
  // const [ selectedUbpr,      setSelectedUbpr ]      = useState([])

  /* methods */

  const clear = () => {
    const q = {...query}
    q[criterionModalOpen].value.ubpr_code = null
    setQuery(q)
  }

  const handleAdd = () => {
    // logg([ selectedUbpr, selectedPeriod ], 'hm')
    if (!query[criterionModalOpen].value.ubpr_code ||
        !query[criterionModalOpen].value.period) {
          toast('Please select a line item and a period.')
          return
    }
    setCriterionModalOpen(false)
  }

  const setPeriod = (ev) => {
    // logg(criterionModalOpen, 'setPeriod')
    const period = periodsList[ev.target.value]

    const q = {...query}
    q[criterionModalOpen].value.period = period.value
    q[criterionModalOpen].period_label = moment(period.date).format(userConfig.dateFormat)
    setQuery(q)
  }

  const setUbpr = (ev) => {
    const ubpr_h = filteredUbprsList[ev.target.value]
    const q = {...query}
    q[criterionModalOpen].value.ubpr_code = ubpr_h.value
    q[criterionModalOpen].ubpr_label = ubpr_h.label
    setQuery(q)
  }


  return <F>
    <Modal
      ariaHideApp={false}
      className="BaseModal CriterionModal "
      isOpen={criterionModalOpen}
      onRequestClose={ () => setCriterionModalOpen(false) }
      overlayClassName="CriterionModalOverlay"
    >
      <div className='header'>
        <h5 >Select Line Item</h5>
        <div className='close' onClick={() => setCriterionModalOpen(false) }>&times;</div>
      </div>

      <div className='bifold-rows'>
        <div className='col-md-6 '>
          <div className='border-right h-100 bordered-scrolling '>
            <TriSelect {...{
              clear,
              filteredUbprsList, setFilteredUbprsList,
            }} />
            <div className="IncludeUbprsW">{ filteredUbprsList.length && <F>
              <table className='bordered padded' >
                <thead>
                  <tr>
                    <th className="selector">&nbsp;</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  { filteredUbprsList.map((item, idx) => <tr key={idx} >
                      <td>{ [ C.el.br, C.el.h3 ].indexOf(item.value) > -1 ? null :
                        <input type='radio' name='criterion-modal-ubpr'
                          onChange={setUbpr}
                          value={idx} /> }
                      </td>
                      <td>
                        { [ C.el.br, C.el.h3 ].indexOf(item.value) > -1 ? null : item.label }
                        { C.el.h3 === item.value && <b>{item.label}</b> }
                      </td>
                  </tr>) }
                </tbody>
              </table>
            </F> || <F>&nbsp; &nbsp;--</F> }</div>


          </div>
        </div>
        <div className='col-md-6'>
          <div className='h-100 bordered-scrolling '>
            <div className='header'>
              <h5 >Periods</h5>
            </div>


            { periodsList.map((opt, idx) => <div className={`radioselect-item ${opt.relative_s.indexOf('PYE') == -1 ? 'ytd' : 'pye' }`} key={idx} >
              <input type='radio' name='criterion-modal-period' value={idx}
                onChange={setPeriod} />
              <span className='label-1'>{ opt.relative_s }</span>
              <span className='label-2'>{ moment(opt.date).format(userConfig.dateFormat) }</span>
            </div> )}


          </div>
        </div>
      </div>

      <div className='actions pt-2 pb-2 mr-3 '>
        <div className='left'></div>
        <div className='right'>
          <div className='Btn btn-primary' onClick={handleAdd} >Add</div>
        </div>
      </div>

    </Modal>
  </F>
}
export default CriterionModal

